// ** followingCars ** //
const initialState = {
  followingCars: false
}

const followingCars = (state = initialState, action) => {
  switch (action.type) {
    case "SET_FOLLOWING_CARS":
      return { ...state, followingCars: action.val }
    default:
      return state
  }
}

export default followingCars
